import React, { FC, useCallback } from 'react';
import { useField } from 'formik';

import StarIcon from '@mui/icons-material/Star';
import EmptyStarIcon from '@mui/icons-material/StarBorder';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Box from '@mui/material/Box';

type Props = {
  name: string;
  maxStars?: number;
  disabled?: boolean;
};

const StarSelect: FC<Props> = ({ maxStars = 5, name, disabled = false }) => {
  const [{ value, onChange }, { error }] = useField<number | null>(name);

  const handleStarClick = useCallback(
    (value: number) => () => {
      if (disabled) return;

      onChange({
        target: { id: name, value },
      });
    },
    [disabled, onChange, name]
  );

  const starAmount = value ?? 0;

  const starList = [];
  for (let i = 0; i < starAmount; i++) {
    const set = starAmount - 1 === i ? 0 : i + 1;
    starList.push(
      <StarIcon
        onClick={handleStarClick(set)}
        key={i}
        data-testid={i + 1}
        sx={{ cursor: 'pointer' }}
      />
    );
  }

  for (let i = 0; i < maxStars - starAmount; i++) {
    starList.push(
      <EmptyStarIcon
        onClick={handleStarClick(i + starAmount + 1)}
        key={i + starAmount}
        data-testid={i + starAmount + 1}
        sx={{ cursor: 'pointer' }}
      />
    );
  }

  return (
    <Box>
      <FormControl>
        <Box>{starList}</Box>
        {error && (
          <FormHelperText sx={{ color: 'text.error' }}>{error}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default StarSelect;
